import { render } from "./LegalStuff.vue?vue&type=template&id=62b0fbde&scoped=true"
import script from "./LegalStuff.vue?vue&type=script&lang=js"
export * from "./LegalStuff.vue?vue&type=script&lang=js"

import "./LegalStuff.vue?vue&type=style&index=0&id=62b0fbde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b0fbde"]])

export default __exports__